<template>
  <div>
    <p v-if="!isReady">Загрузка...</p>
    <div v-else class="product-form-content">
      <gallery
        :images="images"
        :index="galleryIndex"
        @close="galleryIndex = null"
      />
      <form v-if="mode === 'create'" @submit.prevent="onSubmit">
        <div class="form-tabs">
          <va-tabs v-model="activeTab" grow>
            <va-tab
              v-for="(tab, i) in tabs"
              :key="i"
              :class="{ 'tab-error': hasTabError(i) }"
            >
              <span :class="{ 'error-text': hasTabError(i) }">
                {{ tab.label
                }}<span v-if="hasTabError(i)" class="error-star"> *</span>
              </span>
            </va-tab>
          </va-tabs>
        </div>
        <va-separator class="form-tabs-separator" />
        <product-form-tab-basics
          v-show="activeTab === 0"
          :form-data="formData"
          :validation="$v"
          :mode="mode"
          :errors="validationErrors"
          :categories-search.sync="categoriesSearch"
          :related-products-search.sync="relatedProductsSearch"
          :related-categories-search.sync="relatedCategoriesSearch"
          :bundle-products-search.sync="bundleProductsSearch"
          :filtered-categories="filteredCategories"
          :selected-category-chips="selectedCategoryChips"
          :category-url-prefix="categoryUrlPrefix"
          :product-page-url="productPageUrl"
          :effective-main-category-id="effectiveMainCategoryId"
          :related-products-search-results="relatedProductsSearchResults"
          :related-products-rows="relatedProductsRows"
          :filtered-related-categories="filteredRelatedCategories"
          :florists-options="floristsOptions"
          :florist-id.sync="floristId"
          :bundle-component-rows="bundleComponentRows"
          :bundle-products-search-results="bundleProductsSearchResults"
          :used-in-bundles="usedInBundles"
          :price-current.sync="priceCurrent"
          :price-old.sync="priceOld"
          @update:formData="formData = { ...formData, ...$event }"
          @add-bundle-product="addBundleProduct"
          @remove-bundle-product="removeBundleProduct"
          @add-related-product="addRelatedProduct"
          @remove-related-product="removeRelatedProduct"
          @set-main-category="setMainCategory"
          @remove-category="removeCategory"
          @update-slug="onSlugInput"
        />
        <product-form-tab-description
          v-show="activeTab === 1"
          :form-data="formData"
          :validation="$v"
          :errors="validationErrors"
        />
        <product-form-tab-seo v-show="activeTab === 2" :form-data="formData" />
        <product-form-tab-photos
          v-show="activeTab === 3"
          :product-photos="productPhotos.photos"
          :errors="validationErrors"
          @file-picked="onFilePicked"
          @delete-photo="deleteImg"
          @open-gallery="galleryIndex = $event"
        />
        <product-form-tab-filters
          v-show="activeTab === 4"
          :form-data="formData"
          :mode="mode"
          :colors-search.sync="colorsSearch"
          :components-search.sync="componentsSearch"
          :reasons-search.sync="reasonsSearch"
          :tags-search.sync="tagsSearch"
          :filtered-colors="filteredColors"
          :filtered-components="filteredComponents"
          :filtered-reasons="filteredReasons"
          :filtered-tags="filteredTags"
        />
      </form>
      <div v-else>
        <div class="form-tabs">
          <va-tabs v-model="activeTab" grow>
            <va-tab
              v-for="(tab, i) in tabs"
              :key="i"
              :class="{ 'tab-error': hasTabError(i) }"
            >
              <span :class="{ 'error-text': hasTabError(i) }">
                {{ tab.label
                }}<span v-if="hasTabError(i)" class="error-star"> *</span>
              </span>
            </va-tab>
          </va-tabs>
        </div>
        <va-separator class="form-tabs-separator" />
        <product-form-tab-basics
          v-show="activeTab === 0"
          :form-data="formData"
          :validation="$v"
          :mode="mode"
          :errors="validationErrors"
          :categories-search.sync="categoriesSearch"
          :related-products-search.sync="relatedProductsSearch"
          :related-categories-search.sync="relatedCategoriesSearch"
          :bundle-products-search.sync="bundleProductsSearch"
          :filtered-categories="filteredCategories"
          :selected-category-chips="selectedCategoryChips"
          :category-url-prefix="categoryUrlPrefix"
          :product-page-url="productPageUrl"
          :effective-main-category-id="effectiveMainCategoryId"
          :related-products-search-results="relatedProductsSearchResults"
          :related-products-rows="relatedProductsRows"
          :filtered-related-categories="filteredRelatedCategories"
          :florists-options="floristsOptions"
          :florist-id.sync="floristId"
          :bundle-component-rows="bundleComponentRows"
          :bundle-products-search-results="bundleProductsSearchResults"
          :used-in-bundles="usedInBundles"
          :price-current.sync="priceCurrent"
          :price-old.sync="priceOld"
          @update:formData="formData = { ...formData, ...$event }"
          @add-bundle-product="addBundleProduct"
          @remove-bundle-product="removeBundleProduct"
          @add-related-product="addRelatedProduct"
          @remove-related-product="removeRelatedProduct"
          @set-main-category="setMainCategory"
          @remove-category="removeCategory"
          @update-slug="onSlugInput"
        />
        <product-form-tab-description
          v-show="activeTab === 1"
          :form-data="formData"
          :validation="$v"
          :errors="validationErrors"
        />
        <product-form-tab-seo v-show="activeTab === 2" :form-data="formData" />
        <product-form-tab-photos
          v-show="activeTab === 3"
          :product-photos="productPhotos.photos"
          :errors="validationErrors"
          @file-picked="onFilePicked"
          @delete-photo="deleteImg"
          @open-gallery="galleryIndex = $event"
        />
        <product-form-tab-filters
          v-show="activeTab === 4"
          :form-data="formData"
          :mode="mode"
          :colors-search.sync="colorsSearch"
          :components-search.sync="componentsSearch"
          :reasons-search.sync="reasonsSearch"
          :tags-search.sync="tagsSearch"
          :filtered-colors="filteredColors"
          :filtered-components="filteredComponents"
          :filtered-reasons="filteredReasons"
          :filtered-tags="filteredTags"
        />
      </div>
      <div class="mt-4 text-center action-buttons-fixed">
        <va-button
          color="success"
          type="button"
          @click="onSubmit()"
        >
          Сохранить
        </va-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import api from "@/api/axios";
import { mapState, mapActions, mapMutations } from "vuex";
import VueGallery from "vue-gallery";
import { required } from "vuelidate/lib/validators";
import slugify from "slugify";
import ProductFormTabBasics from "./form-tabs/ProductFormTabBasics.vue";
import ProductFormTabDescription from "./form-tabs/ProductFormTabDescription.vue";
import ProductFormTabSeo from "./form-tabs/ProductFormTabSeo.vue";
import ProductFormTabPhotos from "./form-tabs/ProductFormTabPhotos.vue";
import ProductFormTabFilters from "./form-tabs/ProductFormTabFilters.vue";

const TAB_HASHES = ["main", "description", "seo", "photos", "filters"];

const createEmptyFormData = () => ({
  name: "",
  description: "",
  categories: [],
  colors: [],
  tags: [],
  components: [],
  reasons: [],
  related_products: [],
  related_categories: [],
  card_type: "normal",
  is_available: true,
  is_hidden: false,
  show_components: false,
  is_price_auto_calculated: false,
  is_individual_order: false,
  price_min: null,
  price_step: null,
  is_new: false,
  is_discount: false,
  size_width: null,
  size_height: null,
  meta_title: null,
  meta_description: null,
  product_url: null,
  main_category_id: null,
  slug: "",
  delivery_info: null,
  payment_info: null,
  price: { current: null, old: null },
});

export default {
  name: "ProductForm",
  components: {
    gallery: VueGallery,
    ProductFormTabBasics,
    ProductFormTabDescription,
    ProductFormTabSeo,
    ProductFormTabPhotos,
    ProductFormTabFilters,
  },
  props: {
    mode: {
      type: String,
      default: "create",
      validator: (v) => ["create", "edit"].includes(v),
    },
    productInfo: { type: Object, default: null },
  },
  data() {
    return {
      activeTab: 0,
      formData: createEmptyFormData(),
      productPhotos: { photos: [] },
      selectedFile: [],
      bundleComponentRows: [],
      bundleProductsSearch: "",
      bundleProductsSearchResults: [],
      bundleProductsSearchDebounceTimer: null,
      categoriesSearch: "",
      relatedProductsSearch: "",
      relatedProductsSearchDebounceTimer: null,
      relatedProductsSearchResults: [],
      relatedProductsRows: [],
      relatedCategoriesSearch: "",
      colorsSearch: "",
      componentsSearch: "",
      reasonsSearch: "",
      tagsSearch: "",
      florists: [],
      floristId: "",
      sizes: [],
      images: [],
      galleryIndex: null,
      componentLoader: true,
      dataLoaded: false,
      loadedProduct: null,
      slugTouched: false,
    };
  },
  validations() {
    return {
      formData: {
        name: { required },
      },
    };
  },
  computed: {
    ...mapState({
      productData: (state) => state.product.productData,
    }),
    tabs() {
      const t = [
        { label: "Основные" },
        { label: "Описание" },
        { label: "SEO и инфо" },
        { label: "Фото" },
        { label: "Фильтры / характеристики" },
      ];
      return t;
    },
    isReady() {
      return this.dataLoaded && !this.componentLoader;
    },
    priceCurrent: {
      get() {
        return this.formData.price?.current ?? "";
      },
      set(v) {
        if (!this.formData.price)
          this.$set(this.formData, "price", { current: null, old: null });
        this.formData.price.current = v;
      },
    },
    priceOld: {
      get() {
        return this.formData.price?.old ?? "";
      },
      set(v) {
        if (!this.formData.price)
          this.$set(this.formData, "price", { current: null, old: null });
        this.formData.price.old = v;
      },
    },
    floristsOptions() {
      return (this.florists || []).filter(
        (f) => f != null && f.id != null && f.id !== ""
      );
    },
    autoCalculatedPrice() {
      if (!this.bundleComponentRows.length) return 0;
      return this.bundleComponentRows.reduce((sum, row) => {
        const qty = Math.max(1, Number(row.quantity) || 1);
        const d = Math.min(100, Math.max(0, Number(row.discount_percent) || 0));
        const p = Number(
          row.product.price_current ?? row.product.price?.current ?? 0
        );
        return sum + p * qty * (1 - d / 100);
      }, 0);
    },
    filteredCategories() {
      if (!this.productData?.categories) return [];
      if (!this.categoriesSearch?.trim()) return this.productData.categories;
      const q = this.categoriesSearch.toLowerCase().trim();
      return this.productData.categories.filter((c) =>
        c.name?.toLowerCase().includes(q)
      );
    },
    selectedCategoryChips() {
      const selected = this.normalizeArray(this.formData.categories);
      const all = this.productData?.categories || [];
      return selected
        .map((id) => {
          const cat = all.find((c) => String(c.id) === String(id));
          return cat
            ? { id: cat.id, name: cat.name }
            : { id: Number(id) || id, name: `#${id}` };
        })
        .filter(Boolean);
    },
    effectiveMainCategoryId() {
      if (this.formData.main_category_id != null && this.formData.main_category_id !== "") {
        const main = String(this.formData.main_category_id);
        const selected = this.normalizeArray(this.formData.categories);
        if (selected.includes(main)) return Number(main);
      }
      const chips = this.selectedCategoryChips;
      if (!chips.length) return null;
      return [...chips].sort((a, b) => Number(a.id) - Number(b.id))[0].id;
    },
    categoryUrlPrefix() {
      const mainId = this.effectiveMainCategoryId;
      if (mainId == null) return "";
      return this.buildCategoryPathPrefix(mainId);
    },
    productPageUrl() {
      const slug = (this.formData.slug || "").trim().replace(/^\/+|\/+$/g, "");
      if (!slug) return "";
      const prefix = this.categoryUrlPrefix;
      const path = prefix ? `${prefix}/${slug}` : slug;
      const apiBase = process.env.VUE_APP_BASE_URL || "";
      const siteBase = apiBase.includes("api-dev")
        ? "https://dev.florida55.ru"
        : "https://florida55.ru";
      return `${siteBase}/${path}/`;
    },
    filteredRelatedCategories() {
      if (!this.productData?.categories) return [];
      if (!this.relatedCategoriesSearch?.trim())
        return this.productData.categories;
      const q = this.relatedCategoriesSearch.toLowerCase().trim();
      return this.productData.categories.filter((c) =>
        c.name?.toLowerCase().includes(q)
      );
    },
    filteredColors() {
      if (!this.productData?.colors) return [];
      if (!this.colorsSearch?.trim()) return this.productData.colors;
      const q = this.colorsSearch.toLowerCase().trim();
      return this.productData.colors.filter((c) =>
        c.name?.toLowerCase().includes(q)
      );
    },
    filteredComponents() {
      if (!this.productData?.components) return [];
      if (!this.componentsSearch?.trim()) return this.productData.components;
      const q = this.componentsSearch.toLowerCase().trim();
      return this.productData.components.filter((c) =>
        c.title?.toLowerCase().includes(q)
      );
    },
    filteredReasons() {
      if (!this.productData?.reasons) return [];
      if (!this.reasonsSearch?.trim()) return this.productData.reasons;
      const q = this.reasonsSearch.toLowerCase().trim();
      return this.productData.reasons.filter((r) =>
        r.name?.toLowerCase().includes(q)
      );
    },
    filteredTags() {
      if (!this.productData?.tags) return [];
      if (!this.tagsSearch?.trim()) return this.productData.tags;
      const q = this.tagsSearch.toLowerCase().trim();
      return this.productData.tags.filter((t) =>
        t.name?.toLowerCase().includes(q)
      );
    },
    usedInBundles() {
      if (this.mode !== "edit" || !this.loadedProduct?.used_in_bundles) return [];
      return Array.isArray(this.loadedProduct.used_in_bundles)
        ? this.loadedProduct.used_in_bundles
        : [];
    },
    validationErrors() {
      const e = {};
      if (this.$v.formData?.name?.$error && !this.$v.formData.name.required)
        e.name = true;
      return e;
    },
  },
  watch: {
    activeTab(tabIndex) {
      this.syncHashWithTab(tabIndex);
    },
    "$route.hash"(hash) {
      this.applyTabFromHash(hash);
    },
    "productPhotos.photos": {
      handler() {
        this.images = (this.productPhotos.photos || [])
          .map((p) => p.url)
          .filter(Boolean);
      },
      deep: true,
    },
    autoCalculatedPrice(v) {
      if (this.formData.is_price_auto_calculated)
        this.priceCurrent = Number(v) || 0;
    },
    "formData.is_price_auto_calculated"(v) {
      if (v) this.priceCurrent = Number(this.autoCalculatedPrice) || 0;
    },
    bundleProductsSearch() {
      this.onBundleProductsSearchInput();
    },
    relatedProductsSearch() {
      this.onRelatedProductsSearchInput();
    },
    "formData.name"(newName) {
      if (this.mode === "create" && !this.slugTouched) {
        this.formData.slug = this.generateProductUrlFromName(newName) || "";
      }
    },
    "formData.categories"(cats) {
      const ids = this.normalizeArray(cats).map(String);
      const mainId = this.formData.main_category_id;
      if (mainId != null && mainId !== "" && !ids.includes(String(mainId))) {
        this.formData.main_category_id = null;
      }
      if (
        (this.formData.main_category_id == null || this.formData.main_category_id === "") &&
        ids.length
      ) {
        const numeric = ids.map(Number).filter((n) => !Number.isNaN(n)).sort((a, b) => a - b);
        if (numeric.length) this.formData.main_category_id = numeric[0];
      }
    },
  },
  created() {
    this.componentLoader = true;
    this.dataLoaded = false;
    this.applyTabFromHash(this.$route.hash);
    if (this.mode === "create") {
      this.initCreate();
    } else {
      this.initEdit();
    }
  },
  methods: {
    ...mapActions({
      fetchProductsByCategory: "product/getProductsByCategory",
      getProductsByCategory: "product/getProductsByCategory",
    }),
    ...mapMutations(["SET_GLOBAL_LOADER"]),
    syncHashWithTab(tabIndex) {
      const targetHash = this.getHashByTabIndex(tabIndex);
      const currentHash = (this.$route.hash || "").replace(/^#/, "");

      if (currentHash === targetHash) {
        return;
      }

      this.$router
        .replace({
          path: this.$route.path,
          query: this.$route.query,
          hash: `#${targetHash}`,
        })
        .catch(() => {});
    },
    applyTabFromHash(hash) {
      const tabIndex = this.getTabIndexByHash(hash);
      if (tabIndex !== null && tabIndex !== this.activeTab) {
        this.activeTab = tabIndex;
      }
    },
    getHashByTabIndex(tabIndex) {
      return TAB_HASHES[tabIndex] || TAB_HASHES[0];
    },
    getTabIndexByHash(hash) {
      const normalizedHash = String(hash || "").replace(/^#/, "");
      const tabIndex = TAB_HASHES.indexOf(normalizedHash);
      return tabIndex >= 0 ? tabIndex : null;
    },
    async initCreate() {
      try {
        await this.loadFlorists();
        this.dataLoaded = true;
      } catch (e) {
        console.error(e);
      } finally {
        this.componentLoader = false;
      }
    },
    async initEdit() {
      try {
        await this.loadProductDetails();
        await this.loadFlorists();
        if (this.loadedProduct) this.initializeFlorist(this.loadedProduct);
        this.dataLoaded = true;
      } catch (e) {
        console.error(e);
      } finally {
        this.componentLoader = false;
      }
    },
    async loadProductDetails() {
      const slug = this.productInfo?.slug;
      if (!slug) return;
      const res = await api.get(`/admin/products/${slug}`);
      const data = res.data.data || res.data;
      if (data) {
        this.loadedProduct = data;
        this.formData = this.productToFormData(data);
        if (data.photos && Array.isArray(data.photos)) {
          this.productPhotos.photos = [...data.photos];
        }
        this.initializeBundleFromProduct(data);
        this.initializeRelatedProductsFromProduct(data);
        this.initializeSizes(data);
      }
    },
    productToFormData(p) {
      const arr = (a) =>
        Array.isArray(a)
          ? a.filter((x) => x?.id != null).map((x) => String(x.id))
          : [];
      return {
        name: p.name || "",
        description: p.description || "",
        categories: arr(p.categories),
        colors: arr(p.colors),
        tags: arr(p.tags),
        components: arr(p.components),
        reasons: arr(p.reasons),
        related_products: arr(p.related_products),
        related_categories: arr(p.related_categories),
        card_type: p.card_type || "normal",
        is_available: p.is_available !== false,
        is_hidden: !!p.is_hidden,
        show_components: !!p.show_components,
        is_price_auto_calculated: !!p.is_price_auto_calculated,
        is_individual_order: !!p.is_individual_order,
        price_min: p.price_min ?? null,
        price_step: p.price_step ?? null,
        is_new: !!p.is_new,
        is_discount: !!p.is_discount,
        size_width: p.size_width ?? null,
        size_height: p.size_height ?? null,
        meta_title: p.meta_title ?? null,
        meta_description: p.meta_description ?? null,
        product_url: p.product_url ?? null,
        main_category_id: p.main_category_id ?? null,
        delivery_info: p.delivery_info ?? null,
        payment_info: p.payment_info ?? null,
        price: {
          current: p.price?.current ?? p.price_current ?? null,
          old: p.price?.old ?? p.price_old ?? null,
        },
        id: p.id,
        slug: p.slug || "",
      };
    },
    initializeBundleFromProduct(p) {
      const bc = p.bundle_components;
      if (bc && Array.isArray(bc)) {
        this.bundleComponentRows = bc
          .filter(
            (el) => el && (el.component_product_id || el.component_product?.id)
          )
          .map((el) => {
            const pp = el.component_product || {};
            return {
              product: {
                id: pp.id ?? el.component_product_id,
                name: pp.name ?? "",
                price_current: pp.price_current ?? pp.price?.current ?? 0,
              },
              quantity: Number(el.quantity) || 1,
              discount_percent: Number(el.discount_percent) || 0,
            };
          });
      }
    },
    initializeRelatedProductsFromProduct(p) {
      const rp = p.related_products;
      if (rp && Array.isArray(rp)) {
        this.relatedProductsRows = rp
          .filter((x) => x && x.id != null)
          .map((x) => ({ id: x.id, name: x.name ?? "" }));
      } else {
        this.relatedProductsRows = [];
      }
    },
    initializeFlorist(p) {
      const f = p?.florist;
      if (f && f.id != null) {
        const found = this.florists.find((x) => Number(x.id) === Number(f.id));
        this.floristId = found || { id: f.id, name: f.name || "" };
      } else {
        this.floristId = "";
      }
    },
    initializeSizes(p) {
      const sd = this.productData?.sizes;
      if (sd && Array.isArray(sd) && sd.length) {
        this.sizes = JSON.parse(JSON.stringify(sd));
        this.sizes.forEach((s) => {
          if (!s.qty) s.qty = 9999;
        });
      }
    },
    onRelatedProductsSearchInput() {
      if (this.relatedProductsSearchDebounceTimer) {
        clearTimeout(this.relatedProductsSearchDebounceTimer);
      }
      this.relatedProductsSearchDebounceTimer = setTimeout(
        () => this.searchRelatedProducts(),
        300
      );
    },
    async searchRelatedProducts() {
      const q = this.relatedProductsSearch?.trim();
      if (!q) {
        this.relatedProductsSearchResults = [];
        return;
      }
      try {
        const res = await api.get("/admin/products", {
          params: { query: q, per_page: 20, page: 1 },
        });
        const data = res.data.data || res.data;
        const list = Array.isArray(data) ? data : data?.data || [];
        const exclude =
          this.mode === "edit" && this.formData.id ? this.formData.id : null;
        const addedIds = this.relatedProductsRows.map((r) => r.id);
        this.relatedProductsSearchResults = list.filter(
          (p) => p.id !== exclude && !addedIds.includes(p.id)
        );
      } catch (e) {
        this.relatedProductsSearchResults = [];
      }
    },
    addRelatedProduct(p) {
      if (!p || this.relatedProductsRows.some((r) => r.id === p.id)) return;
      this.relatedProductsRows.push({ id: p.id, name: p.name ?? "" });
      const ids = (this.formData.related_products || []).map(String);
      if (!ids.includes(String(p.id))) {
        this.formData.related_products = [...ids, String(p.id)];
      }
    },
    removeRelatedProduct(idx) {
      const row = this.relatedProductsRows[idx];
      if (row == null) return;
      this.relatedProductsRows.splice(idx, 1);
      this.formData.related_products = (this.formData.related_products || []).filter(
        (id) => String(id) !== String(row.id)
      );
    },
    async loadFlorists() {
      try {
        const res = await api.get("/admin/florists", { params: { all: 1 } });
        this.florists = res.data.data || res.data || [];
      } catch (e) {
        this.florists = [];
      }
    },
    normalizeArray(arr) {
      if (!arr || !Array.isArray(arr)) return [];
      return arr.map((x) => String(x));
    },
    setMainCategory(categoryId) {
      this.formData.main_category_id = Number(categoryId);
    },
    removeCategory(categoryId) {
      const id = String(categoryId);
      this.formData.categories = this.normalizeArray(this.formData.categories).filter(
        (x) => x !== id
      );
      if (String(this.formData.main_category_id) === id) {
        this.formData.main_category_id = null;
      }
    },
    onSlugInput(value) {
      this.slugTouched = true;
      this.formData.slug = String(value || "").trim();
    },
    buildCategoryPathPrefix(categoryId) {
      const all = this.productData?.categories || [];
      const byId = {};
      all.forEach((c) => {
        byId[String(c.id)] = c;
      });
      const slugs = [];
      let curr = byId[String(categoryId)];
      let guard = 0;
      while (curr && guard < 10) {
        slugs.unshift(curr.slug);
        curr =
          curr.parent_id != null && curr.parent_id !== ""
            ? byId[String(curr.parent_id)]
            : null;
        guard += 1;
      }
      return slugs.join("/");
    },
    formatBackendErrors(errors) {
      if (!errors || typeof errors !== "object") {
        return "";
      }
      const errorLines = Object.entries(errors).flatMap(([field, messages]) => {
        const normalizedMessages = Array.isArray(messages)
          ? messages
          : [messages];
        return normalizedMessages
          .filter(Boolean)
          .map((message) => `${field}: ${String(message)}`);
      });
      return errorLines.join("\n");
    },
    generateProductUrlFromName(name) {
      if (!name || !String(name).trim()) {
        return null;
      }
      return slugify(String(name).trim(), {
        lower: true,
        strict: true,
      });
    },
    filteredSizes() {
      if (!this.productData?.sizes) return [];
      return this.productData.sizes.map((s) => ({ id: s.id, qty: 9999 }));
    },
    buildBundlePayload() {
      return this.bundleComponentRows.map((row) => ({
        component_product_id: Number(row.product.id),
        quantity: Math.max(1, Number(row.quantity) || 1),
        discount_percent: Math.min(
          100,
          Math.max(0, Number(row.discount_percent) || 0)
        ),
      }));
    },
    onBundleProductsSearchInput() {
      if (this.bundleProductsSearchDebounceTimer)
        clearTimeout(this.bundleProductsSearchDebounceTimer);
      this.bundleProductsSearchDebounceTimer = setTimeout(
        () => this.searchBundleProducts(),
        300
      );
    },
    async searchBundleProducts() {
      const q = this.bundleProductsSearch?.trim();
      if (!q) {
        this.bundleProductsSearchResults = [];
        return;
      }
      try {
        const res = await api.get("/admin/products", {
          params: { query: q, per_page: 20, page: 1 },
        });
        const data = res.data.data || res.data;
        const list = Array.isArray(data) ? data : data?.data || [];
        const ids = this.bundleComponentRows.map((r) => r.product.id);
        const exclude =
          this.mode === "edit" && this.formData.id ? this.formData.id : null;
        this.bundleProductsSearchResults = list.filter(
          (p) => p.id !== exclude && !ids.includes(p.id)
        );
      } catch (e) {
        this.bundleProductsSearchResults = [];
      }
    },
    addBundleProduct(p) {
      if (!p || this.bundleComponentRows.some((r) => r.product.id === p.id))
        return;
      this.bundleComponentRows.push({
        product: {
          id: p.id,
          name: p.name,
          price_current: p.price?.current ?? p.price_current,
        },
        quantity: 1,
        discount_percent: 0,
      });
    },
    removeBundleProduct(idx) {
      this.bundleComponentRows.splice(idx, 1);
    },
    async checkImgs() {
      const existing = (this.productPhotos.photos || [])
        .filter((p) => p.id && !p.local)
        .map((p) => p.id);
      let newIds = [];
      if (this.selectedFile.length) {
        const fd = new FormData();
        this.selectedFile.forEach((f, i) => fd.append(`file[${i}]`, f, f.name));
        const res = await api.post("/upload-file", fd);
        newIds = (res.data || []).map((x) => x.id);
      }
      return [...existing, ...newIds];
    },
    onFilePicked(ev) {
      const file = ev.target.files?.[0];
      if (!file) return;
      if (file.size > 5 * 1048576) {
        Vue.notify({
          type: "error",
          title: "Превышен максимально допустимый размер (максимум 5МБ)",
        });
        ev.target.value = "";
        return;
      }
      if ((this.productPhotos.photos || []).length >= 6) {
        alert("Максимум 6");
        return;
      }
      this.selectedFile.push(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        this.productPhotos.photos.push({
          url: e.target.result,
          local: true,
          file,
        });
      };
      reader.readAsDataURL(file);
    },
    deleteImg(idx) {
      if (!confirm("Вы действительно хотите удалить ?")) return;
      const photo = this.productPhotos.photos[idx];
      if (photo?.local && photo.file) {
        const i = this.selectedFile.indexOf(photo.file);
        if (i >= 0) this.selectedFile.splice(i, 1);
      }
      this.productPhotos.photos.splice(idx, 1);
    },
    hasTabError(i) {
      if (!this.$v?.$dirty && !this.$v?.$error) return false;
      if (i === 0)
        return (
          this.$v.formData?.name?.$error && !this.$v.formData.name.required
        );
      return false;
    },
    getValidationMessage() {
      const invalidFields = [];
      if (this.$v.formData?.name?.$error && !this.$v.formData.name.required) {
        invalidFields.push("название");
      }
      if (invalidFields.length === 0) {
        return "Проверьте обязательные поля";
      }
      return `Проверьте вкладки с ошибками: ${invalidFields.join(" и ")}`;
    },
    getFirstErrorTab() {
      for (let i = 0; i <= 4; i++) if (this.hasTabError(i)) return i;
      return -1;
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        const tab = this.getFirstErrorTab();
        if (tab >= 0) this.activeTab = tab;
        const msg = this.getValidationMessage();
        const notifyPayload = {
          type: "error",
          title: "Заполните обязательные поля",
          text: msg,
          message: msg,
        };
        Vue.notify(notifyPayload);
        return;
      }
      try {
        this.SET_GLOBAL_LOADER(true);
        const photos = await this.checkImgs();
        const sizes = this.filteredSizes();
        const payload = this.buildPayload(photos, sizes);
        if (this.mode === "create") {
          const res = await api.post("/admin/products", payload);
          if (res.status === 201) this.afterCreate(payload);
        } else {
          const routeSlug =
            this.loadedProduct?.slug || this.formData.slug || payload.slug;
          await api.put(`/admin/products/${routeSlug}`, payload);
          if (payload.slug) {
            this.formData.slug = payload.slug;
            if (this.loadedProduct) this.loadedProduct.slug = payload.slug;
          }
          Vue.notify({ type: "success", title: "Товар успешно сохранен" });
          const cat = this.$route.query.category;
          await this.getProductsByCategory(
            cat || "all_products_without_category"
          );
          this.$emit("saved");
        }
      } catch (err) {
        const d = err?.response?.data;
        const msg = d?.message || d?.error || "Не удалось сохранить товар";
        const backendErrorsText = this.formatBackendErrors(d?.errors);
        Vue.notify({
          type: "error",
          title: msg,
          text: backendErrorsText || msg,
          message: backendErrorsText || msg,
        });
      } finally {
        this.SET_GLOBAL_LOADER(false);
      }
    },
    buildPayload(photos, sizes) {
      const n = this.normalizeArray;
      const floristId =
        this.floristId &&
        typeof this.floristId === "object" &&
        this.floristId.id != null
          ? Number(this.floristId.id)
          : null;
      const priceCurrent = this.formData.is_price_auto_calculated
        ? Number(this.autoCalculatedPrice)
        : Number(this.priceCurrent) || 0;
      const priceOld = this.priceOld ? Number(this.priceOld) : null;
      const slug =
        (this.formData.slug || "").trim() ||
        this.generateProductUrlFromName(this.formData.name) ||
        null;
      const mainCategoryId =
        this.effectiveMainCategoryId != null
          ? Number(this.effectiveMainCategoryId)
          : null;
      const payload = {
        name: this.formData.name,
        slug,
        description: this.formData.description,
        price_current: priceCurrent,
        price_old: priceOld,
        is_new: !!this.formData.is_new,
        is_discount: !!this.formData.is_discount,
        is_available: this.formData.is_available !== false,
        is_hidden: !!this.formData.is_hidden,
        size_width: this.formData.size_width || null,
        size_height: this.formData.size_height || null,
        meta_title: this.formData.meta_title || null,
        meta_description: this.formData.meta_description || null,
        main_category_id: mainCategoryId,
        delivery_info: this.formData.delivery_info || null,
        payment_info: this.formData.payment_info || null,
        categories: n(this.formData.categories).map(Number),
        reasons: n(this.formData.reasons).map(Number),
        colors: n(this.formData.colors).map(Number),
        sizes,
        photos,
        components: n(this.formData.components).map(Number),
        bundle_components: this.buildBundlePayload(),
        show_components: !!this.formData.show_components,
        is_price_auto_calculated: !!this.formData.is_price_auto_calculated,
        is_individual_order: !!this.formData.is_individual_order,
        price_min: this.formData.is_individual_order ? Number(this.formData.price_min) || null : null,
        price_step: this.formData.is_individual_order ? Number(this.formData.price_step) || null : null,
        card_type: this.formData.card_type || "normal",
        related_products: n(this.formData.related_products).map(Number),
        related_categories: n(this.formData.related_categories).map(Number),
        florist_id: floristId,
      };
      payload.tags = n(this.formData.tags).map(Number);
      return payload;
    },
    afterCreate() {
      const cats = this.formData.categories || [];
      if (cats.length === 0) {
        this.fetchProductsByCategory("all_products_without_category").then(() =>
          this.$emit("close")
        );
      } else {
        const cat = this.productData?.categories?.find(
          (c) => c.id === Number(cats[0])
        );
        if (cat) {
          if (this.$route.query.category === cat.slug) {
            this.fetchProductsByCategory(cat.slug).then(() =>
              this.$emit("close")
            );
          } else {
            this.$router.push({
              path: "/admin/products",
              query: { category: cat.slug },
            });
            this.fetchProductsByCategory(cat.slug).then(() =>
              this.$emit("close")
            );
          }
        } else {
          this.$emit("close");
        }
      }
    },
  },
};
</script>

<style scoped>
.product-form-content {
  padding-bottom: 80px;
  display: grid;
  gap: 10px;
}
.form-tabs,
.form-tabs-separator {
  grid-column: 1 / -1;
}
.form-tabs {
  margin-bottom: 8px;
}
.tab-content {
  grid-column: 1 / -1;
}
.action-buttons-fixed {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 10;
}
.error-text {
  color: #ff4444;
}
.error-star {
  color: #ff4444;
  font-weight: bold;
}
.tab-error {
  color: #ff4444;
}
</style>
